import { useEffect, useState } from "react";

import {
	useGetLoggedIn,
	useGetProStatus,
	useGetProfileData
} from "_common/hooks/auth";
import { STREAM_TIER }                                                from "_components/pages/proPage/constants";
import { useGetCanWatchMoreContent, useGetDuplicatePlayback }         from "_jotai/compulsoryLogin";
import { useGetCanWatchMoreProContent, useSetCanWatchMoreProContent } from "_jotai/rooterPro";

import Presentation, {
	BUY_PRO_WALL,
	DOWNLOAD_APP_WALL,
	DUPLICATE_STREAM_WALL,
	LOGIN_WALL,
	PRO_EXPIRED_WALL,
	UNSUPPORTED_BROWSER,
	WATCH_AD_WALL
} from "./presentation";

const component = props => {
	const [ browserBlocked, setBrowserBlocked ] = useState ( false );
	const canWatchMoreContent                   = useGetCanWatchMoreContent ();
	const duplicateStream                       = useGetDuplicatePlayback ();
	const isLoggedIn                            = useGetLoggedIn ();
	const userProfile                           = useGetProfileData ();
	const isProUser                             = useGetProStatus ();
	const canWatchMoreProContent                = useGetCanWatchMoreProContent ();
	const [ wasOncePro, setWasOncePro ]         = useState ( false );
	const setCanWatchMoreProContent             = useSetCanWatchMoreProContent ();

	const streamTier      = props?.streamTier?.toString ();
	const isRegularStream = streamTier === STREAM_TIER.REGULAR_STREAM;
	const isWatchAdStream = streamTier === STREAM_TIER.MID_STREAM;
	const isOwnStream     = userProfile?.id === props?.broadcasterId;

	useEffect ( () => {

		setWasOncePro ( prev => prev || isProUser );

		if ( isProUser )
			setCanWatchMoreProContent ( isProUser );

	}, [ isProUser ] );

	const checkBrave = async () => {
		const isBrave = await navigator?.brave?.isBrave ();

		if ( isBrave )
			setBrowserBlocked ( true );
	};

	useEffect ( () => {
		checkBrave ();
	}, [] );

	const getWallType = () => {
		if ( duplicateStream )
			return DUPLICATE_STREAM_WALL;

		if ( wasOncePro && !isProUser )
			return PRO_EXPIRED_WALL;

		if ( isWatchAdStream && props?.adExtConfig?.postExtn === "buy_pro" )
			return DOWNLOAD_APP_WALL;

		if ( isWatchAdStream )
			return WATCH_AD_WALL;

		return BUY_PRO_WALL;
	};

	// For Non-Logged In Users
	if ( !isLoggedIn ) {
		return (
			<Presentation
				canWatchMoreContent = { isRegularStream && canWatchMoreContent }
				type                = { LOGIN_WALL }
				{ ...props }
			/>
		);

	}

	// Logged In but isOwnStream or regularStream or video
	if ( isOwnStream || isRegularStream || props?.isVideo || props?.isReel ) {
		return (
			<Presentation
				canWatchMoreContent = { true }
				{ ...props }
			/>
		);
	}

	return (
		<Presentation
			browserBlocked               = { browserBlocked }
			canWatchMoreContent          = { canWatchMoreProContent && !duplicateStream }
			type                         = { getWallType () }
			{ ...props }
		/>
	);

};

export default component;
